<template>
  <v-layout class="my-3">
    <!-- Radio buttons propogate only on non-marlin plans -->
    <v-flex v-if="!marlinCheck" class="xs1">
      <v-radio :value="plan" :disabled="!minLoanAmountMet" />
    </v-flex>
    <v-flex
      column
      class="clickable"
      @click="switchDetailsStatus"
    >
      <div  class="plan subheading text-xs-left">
        <!-- If this is a Marlin plan, we display the monthly payment using the monthlyMarlinPayment method -->
        <strong v-if="marlinCheck">
          ${{monthlyMarlinPayment(loanTotal, plan.planLength)}} per month for {{plan.planLength}} months 
        </strong>
        <strong v-else-if="wellsfargoCheck" v-html="wellsfargoCalculatedPlanInfo">
        </strong>
        <div v-else-if="!marlinCheck && plan.planLength">
          <strong v-if="!minLoanAmountMet">
            Plan {{ plan.planNumber }} requires a minimum loan amount of ${{ plan.minLoanAmount }}
          </strong>
          <!-- GreenSky -->
          <strong v-else>
            Plan {{ plan.planNumber }}: {{ plan.planDescription }}
            <br/>
            <br/>
            <div v-if="plan.promo">
              **Promotional** - ${{ monthlyPayment(plan.planLength, plan.promoAPR, loanTotal) }} for {{ plan.promo }} months
            </div>
            {{ plan.promo ? 'Post Promo - ' : '' }}${{ monthlyPayment(plan.planLength, plan.apr, loanTotal) }} per month**
          </strong>
        </div>
        <!-- If no plan length, use 12 months as default/example -->
        <strong v-else>
          ${{ monthlyPayment(12, plan.apr, loanTotal) }} per month, based on 1 year term*
          <br/>
          with Plan {{ plan.planNumber }}
          <br/>
          <p class="mb-0 caption"> *Length of actual term may vary.</p>
        </strong>
        <p v-show="plan.maintenance" class="caption text-xs-right"> {{ plan.maintenance }} Maintenance </p>
      </div>
      <div
        class="caption text-xs-left pr-2" v-if="!wellsfargoCheck"
      >
        Total Plan Term of {{ plan.planLength }} months
      </div>

      <div>
        <div
          v-if="showDetails"
          class="my-2 pr-4 plan-details"
        >
          <div
            class="text-xs-left"
          >
            {{ plan.longDescription }}
          </div>
          <br/>
          <div v-if="wellsfargoCheck" v-html="wellsfargoDisclosures">
          </div>
          <div v-if="!marlinCheck & !wellsfargoCheck" class="text-xs-left caption">
            **The Scheduled Payment After Promotional Period amount assumes that the total
            purchase balance is not paid in full within the promotional period and that
            interest charges accrued during the promotional period are not waived
            <br/>
            <br/>
            {{ plan.disclosure }}
          </div>

        </div>
        <div
          v-if="!showDetails"
          class="secondary--text"
        >
          View More
        </div>
        <div
          v-else
          class="secondary--text"
        >
          View Less
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapState } from 'vuex'
  import { marlin } from 'Helpers/lenders.js'

  export default {
    name: 'OfferCard',
    data () {
      return {
        showDetails: false,
        marlin,
      }
    },
    props: {
      loanTotal: {
        type: Number,
        default: 0
      },
      plan: {
        type: Object,
        default: () => {}
      },
      // Prop created and passed down to activate marlinMonthlyPayment()
      marlinCheck:{
        type: Boolean,
        default: false
      },
      wellsfargoCheck: {
        type: Boolean,
        default: false
      },
      currentLender: {
        type: Object,
      },
    },
    computed: {
      ...mapState({
      hasPreQual: state => state.preQualification.hasPreQual
      }),
      wellsfargoCalculatedPlanInfo() {
        if (this.minLoanAmountMet){
          return ` ${this.plan.monthlyPaymentAmount ? this.plan.monthlyPaymentAmount : '' } per month
            with Plan ${this.plan.planNumber}          
            <br/>
            <span class="caption"> ${ this.plan.description }`
        } else {
          return `Plan ${this.plan.planNumber} requires a minimum loan amount of $${this.plan.minLoanAmount}`
        }
      },
      wellsfargoDisclosures() {
        if(this.minLoanAmountMet){
          return `
          <div class="caption"> ${this.plan.bucketDisclosure1}
          </br>
          ${this.plan.bucketDisclosure2}
          </div>`
        }
        return ''
      },
      minLoanAmountMet() {
        return this.plan.minLoanAmount == null || this.plan.minLoanAmount <= this.loanTotal
      }
    },
    methods: {
      monthlyPayment (length, apr, total) {
        const decimalApr = apr / 100
        return (total > 0)
          ? (apr > 0)
            ? parseInt(((decimalApr / 12) * total) / (1 - (1 + (decimalApr / 12)) ** (-1 * length)))
            : parseInt(total / length)
          : 0
      },
      //Marlin montly payment estimator
      monthlyMarlinPayment(total,length){
        let decimal
        // Range between Min Loan Amount - $9,999
        if( total>=marlin.minLoanAmount && total<=9999 ) {
          if (length === 24) { 
            decimal=.0492
          } else if ( length===36 ) {
            decimal=.0344
          } else if ( length=== 48) {
            decimal=.0275
          } else if ( length===60 ) {
            decimal=.0231
          }
        // Range between $10,000 - $24,999
        } else if( total>=10000 && total<=24999 ) {
          if (length === 24) { 
            decimal=.0482
          } else if ( length===36 ) {
            decimal=.0338
          } else if ( length=== 48) {
            decimal=.0265
          } else if ( length===60 ) {
            decimal=.0221
          }
        // Range between $25,000 - $49,999
        } else if ( total>=25000 && total<=49999 ) {
          if (length === 24) { 
            decimal=.0477
          } else if ( length===36 ) {
            decimal=.0333
          } else if ( length=== 48) {
            decimal=.0261
          } else if ( length===60 ) {
            decimal=.0216
          }
        // Range between $50,000 - $99,999
        } else if ( total>=50000 && total<=99999 ) {
          if (length === 24) { 
            decimal=.0472
          } else if ( length===36 ) {
            decimal=.0329
          } else if ( length=== 48) {
            decimal=.0257
          } else if ( length===60 ) {
            decimal=.0214
          }
        // Range between $100,000 - $249,999
        } else if( total>=100000 && total<=249999 ) {
          if (length === 24) { 
            decimal=.0463
          } else if ( length===36 ) {
            decimal=.0319
          } else if ( length=== 48) {
            decimal=.0249
          } else if ( length===60 ) {
            decimal=.0208
          }
        // Range between $250,000 and Max Loan Amount
        } else if(total>=250000 && total<=marlin.maxLoanAmount){
          if (length === 24) { 
            decimal=.0461
          } else if ( length===36 ) {
            decimal=.0318
          } else if ( length=== 48) {
            decimal=.0249
          } else if ( length===60 ) {
            decimal=.0208
          }
        }
      return (total>=marlin.minLoanAmount && total<=marlin.maxLoanAmount)? (total*decimal).toFixed() : 0
      },
    
      switchDetailsStatus () {
        this.showDetails = !this.showDetails
      }
    },
  }
</script>

<style scoped lang="scss">
  .clickable {
    cursor: pointer;
  }

  .plan {
  display: flex !important;
  justify-content: space-between !important;
  }

  .plan-details {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
  }
</style>
